import paramsFactory from "../../utils/paramsFactory";
import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/banner?${p}`);
  },
  create(data) {
    return api.post(`/api/admin/banner`, data);
  },
  update(id, data) {
    return api.post(`/api/admin/banner/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/admin/banner/${id}`);
  },
};
